<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <span>
    <v-layout class="align-center entry_filters_left_justified" row>
      <v-flex class="align-center" lg7 md6 sm9 xs7>
        <span>{{ heading }}</span>
      </v-flex>
      <v-flex v-if="!all_open" class="align-start justify-start mr-1" lg1>
        <v-btn class="white mr-4 ml-5" text x-small @click="show = !show">
          <v-icon v-if="!show" dark> mdi-chevron-down </v-icon>
          <v-icon v-if="show" dark> mdi-chevron-up </v-icon></v-btn
        >
      </v-flex>
      <v-flex v-if="true">


              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{on}">
                  <div v-on="on">
                    <span v-html="result"></span>
                      <span class="ml-1 green--text text--darken-2 fine-tune-font">Rank
                         {{ $store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0]['Market_Rank'] }}/
                               <span @click="get_total_opportunities"
                                     class="trade-blue yellow--text  rounded row-pointer pa-1">{{
                                   $store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0]['Market_REO_Count']
                                 }}</span> opportunities
                        (REO<sub>
                          {{
                            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations['reo_summary_values'][0]['REO_col']
                          }},{{
                            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations['reo_summary_values'][0]['REO_row']
                          }}
                        </sub>)
                      </span>
                  </div>
                </template>
                <span>Click here to view these {{
                    $store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0]['Market_REO_Count']
                  }} markets.</span>
              </v-tooltip>




      </v-flex>
    </v-layout>

    <v-layout v-if="show" class="justify-space-between mt-2 mb-2 mr-2" row>
      <v-flex class="blue-grey white--text pa-2" lg12 md7 sm11 xs11>
        <span class="pa-3 transition-ease-in-out">{{ explanation }} </span>
      </v-flex>
    </v-layout>
  </span>
</template>

<script>


import swal from "sweetalert";

export default {
  name: 'result_hover_opportunities',
  props: ['heading', 'explanation', 'result', 'image', 'all_open'],
  watch: {
    all_open: function () {
      this.show = this.all_open;
    },
  },

  data: () => {
    return {
      show: false,
    };
  },

  methods: {

    async get_product_opportunities_list(product) {

      let C_Code = []
      let data = {
        model_number: this.$store.state.app.selectedModelVersion,
        home_market_code: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.home_market,
        product: product
      }
      await this.axios({
        method: 'post',
        baseURL: this.$store.getters.baseUrl,
        url: 'get_product_opportunities_list/',
        data: data,
      })
          .then(response => {
            C_Code = response.data['markets']
          })
          .catch(() => {
            console.log('error')
          })
      swal.close()
      return C_Code
    },

    async get_total_opportunities() {

      const msg = 'Fetching opportunities related to this product selection'
      await swal(msg,
          {
            buttons: false,
            closeOnClickOutside: true,
            closeOnEsc: true,
            icon: 'info',
            timer: 500,
          },
      );
      let product = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code[0]
      await this.reset_filters_to_raw_state()
      swal(msg,
          {
            buttons: false,
            icon: 'info',
          });
      let C_Code = await this.get_product_opportunities_list(product)
      swal(msg);
      console.log(C_Code)
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = C_Code
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = [product]
      await this.update_results_cube()
    }
  }
};
</script>

<style scoped>
.row-pointer {
  cursor: pointer;
}

.fine-tune-font {
  font-size: 14px;
}
</style>
